import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CadastroPoderesService {

  cadastroPoderes$ = new BehaviorSubject(null);
  cadastroPoderesSem$ = new BehaviorSubject(null);
  cadastroPoderesPost$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/grid_clientes_cadastro_de_poderes/" + environment.empresa;
      
      this.http.get(url).subscribe({
        next: (data) => this.cadastroPoderes$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderes$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderes$.unsubscribe(),
        this.cadastroPoderes$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  getAutorizador() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Clientes/ObterSemAutorizadores/" + environment.empresa;
      
      this.http.get(url).subscribe({
        next: (data) => this.cadastroPoderesSem$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesSem$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesSem$.unsubscribe(),
        this.cadastroPoderesSem$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  post(cliente: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      cliente.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CadastroPoderes/IncluirCliente"

      this.http.post(url, cliente, { headers: headers }).subscribe({
        next: (data) => this.cadastroPoderesPost$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesPost$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesPost$.unsubscribe(),
        this.cadastroPoderesPost$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
